<template>
  <div id="payout-requirements-reminder">
    <div>
      <img src="@/assets/images/onboarding/lightbulb.svg" alt="light-bulb" />
    </div>
    <div class="content">
      Hey there! You can now fully explore the platform. While step 3 is
      optional, we highly recommend adding your payout requirements to avoid any
      future issues.
      <router-link
        :to="{ name: 'onboarding-payout-requirements' }"
        class="font-weight-bold ml-1"
      >
        Add payout requirements
      </router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
#payout-requirements-reminder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 73px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1.5px solid #b1cafb;
  background: #fbfdff;
  color: #0364b4;
  font-family: MainFontRegular, sans-serif;
  font-size: 13px;
  font-style: normal;
  line-height: 20px;
  padding: 22px;
  img {
    margin-right: 15px;
  }
  a {
    color: #0364b4;
  }
  @media (max-width: 991px) {
    height: auto;
  }
}
</style>